/**
 * @file The `periodStart` and `periodEnd` of the fiscal year that starts in
 * `startYear`: the first of `fiscalYearStartMonth` and the same date one year
 * later (exclusive), as `YYYY-MM-DD` strings. Consumers: the Settings →
 * Analytics Goals section and the Overview, which both build goal ids from
 * `periodStart`. The dates are calendar dates, so no time zone applies here.
 */
import type { AnalyticsCalendar } from '#types';

import type { AnalyticsFiscalYear } from './index.types';

export const analyticsFiscalYear = (
  fiscalYearStartMonth: AnalyticsCalendar['fiscalYearStartMonth'],
  startYear: number,
): AnalyticsFiscalYear => {
  const month = String(fiscalYearStartMonth).padStart(2, '0');
  return {
    periodStart: `${startYear}-${month}-01`,
    periodEnd: `${startYear + 1}-${month}-01`,
  };
};
